import { Stack } from '@mui/material';
import React, { ComponentProps, useState } from 'react';

import { EsriAttribute } from '../../../api/ach/esri';
import AiAudienceSearch from '../../CustomSegments/AiAudienceSearch';
import EsriLocationBuilder, {
  EsriLocationBuilderProps,
} from '../TargetingLocations/EsriLocationBuilder/EsriLocationBuilder';

type EsriTarget = Pick<EsriLocationBuilderProps, 'adGroupId' | 'adGroupName' | 'lineItemId' | 'momentsType'>;

interface Props {
  onUseSegment: ComponentProps<typeof AiAudienceSearch>['onUseSegment'];
  // Omitted when ESRI picks can't be attached (an unsaved or exclusion list).
  esriTarget?: EsriTarget;
  onClose: () => void;
}

function AiAudienceSearchModal({ onUseSegment, esriTarget, onClose }: Props) {
  const [esri, setEsri] = useState<{ attributes: EsriAttribute[]; query: string } | null>(null);

  return (
    <Stack sx={{ minWidth: !esri ? '80vw' : null, minHeight: !esri ? '80vh' : null }} justifyContent="space-between">
      {/* Hidden rather than unmounted so Back returns to the same search. */}
      <Stack flex={1} sx={{ display: esri ? 'none' : 'flex' }}>
        <AiAudienceSearch
          onUseSegment={onUseSegment}
          onUseEsriAttributes={esriTarget ? (attributes, query) => setEsri({ attributes, query }) : undefined}
          onClose={onClose}
        />
      </Stack>
      {esri && esriTarget && (
        <EsriLocationBuilder
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...esriTarget}
          source="ai_audience"
          initialAttributes={esri.attributes}
          initialNamePrefix={esri.query}
          onBack={() => setEsri(null)}
          onClose={onClose}
        />
      )}
    </Stack>
  );
}

export default AiAudienceSearchModal;
